import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  FormControl,
  FormGroup,
  Grid,
  Icon,
  Paper,
} from "@material-ui/core";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TooltipMat from "@material-ui/core/Tooltip";
import Search from "@material-ui/icons/Search";
import {
  ExcelExport,
  ExcelExportColumn,
  ExcelExportColumnGroup,
} from "@progress/kendo-react-excel-export";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import Chart from "react-google-charts";
import { ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import Dialog from "../../components/Dialog";
import datetimeHelper from "../../helper/datetime-helper";
import { globalHistory } from "../../history";
import { mapActionsToProps as campaignAction } from "../../redux/campaigns";
import { mapActionsToProps } from "../../redux/report/agent";

class ReportAgentPerformence extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      openModal: false,
      campaignId: null,
    };
  }

  async componentDidMount() {
    this.history = globalHistory();
    await this.props.getListCampaigns();
  }

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "campaignId":
            default: {
              if (key.startsWith("gte") || key.startsWith("lte")) {
                if (key == "gte") {
                  and.push({
                    time: {
                      gte: datetimeHelper.toFormat(
                        this.state.filters.where.gte,
                        "YYYY-MM-DD startDay"
                      ),
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    time: {
                      lte: datetimeHelper.toFormat(
                        this.state.filters.where.lte,
                        "YYYY-MM-DD endDay"
                      ),
                    },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    // this.props.getListCampaigns(filters.order, 999, null, null)
  }

  handleChange = (name) => {
    return (e) => {
      return this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    this.setState({ disable: false });
    this.props.getAgentCallDuration(filters.where.gte, filters.where.lte);
  };

  handleDateChangeStart = (gte) => {
    const { filters } = this.state;
    filters.where.gte = datetimeHelper.toFormat(gte, "YYYY-MM-DD");
    this.setState({ gte });
  };

  handleDateChangeEnd = (lte) => {
    const { filters } = this.state;
    filters.where.lte = datetimeHelper.toFormat(lte, "YYYY-MM-DD");
    this.setState({ lte });
  };

  handleCampaignDetailReport(item) {
    this.setState({
      openModal: true,
      item: item,
    });
  }

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };
  _export;
  export = () => {
    this._export.save();
  };

  render() {
    const { classes, listReportAgentCallDuration, listCampaign } = this.props;
    const { filters, item } = this.state;
    const listReportAgentCallDurationResult =
      typeof listReportAgentCallDuration === "object"
        ? Object.keys(listReportAgentCallDuration).map(
            (key) => listReportAgentCallDuration[key]
          )
        : listReportAgentCallDuration;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const dataReport = [
      ["Code", "0 - 1 (minute)", "1 - 3  (minute)", "> 3  (minute)"],
    ];
    for (const key in listReportAgentCallDurationResult) {
      if (listReportAgentCallDurationResult.hasOwnProperty(key)) {
        const value = listReportAgentCallDurationResult[key];
        if (value.agent.code !== "Total") {
          dataReport.push([
            value.agent.code,
            value.zeroToOne,
            value.oneToThree,
            value.threeUpto,
          ]);
        }
      }
    }

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid
                      container
                      spacing={24}
                      style={{ alignItems: "center" }}>
                      {/* <Grid item md={3}>
                                                <SelectValidator
                                                    id="outlined-full-width"
                                                    margin="normal"
                                                    label="Tên chiến dịch"
                                                    variant="outlined"
                                                    className={classes.input}
                                                    onChange={this.handleSearch}
                                                    value={filters.where.campaignId}
                                                    name="campaignId"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    validators={["required"]}
                                                    errorMessages={[`Không được để trống`]}
                                                >
                                                    {
                                                        !!listCampaignResult ? (
                                                            listCampaignResult.map((item, key) => {
                                                                return (
                                                                    <MenuItem key={key} value={item.id}>
                                                                        {item.name}
                                                                    </MenuItem>
                                                                )
                                                            })
                                                        ) : null
                                                    }
                                                </SelectValidator>
                                            </Grid> */}
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="gte"
                          maxDate={new Date()}
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.lte}
                          maxDate={new Date()}
                          minDate={filters.where.gte}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="lte"
                          keyboard
                          ampm={false}
                        />
                      </Grid>
                      <Grid
                        item
                        md={3}
                        style={{ alignItem: "center", display: "flex" }}>
                        <TooltipMat title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </TooltipMat>
                        <TooltipMat title="Tải báo cáo" disableFocusListener>
                          <Fab
                            color="primary"
                            onClick={this.export}
                            className={classes.fab}>
                            <Icon className={classes.add}>save_alt</Icon>
                          </Fab>
                        </TooltipMat>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
                <ExcelExport
                  data={listReportAgentCallDurationResult}
                  fileName="Báo cáo cuộc gọi tự động.xlsx"
                  ref={(exporter) => (this._export = exporter)}>
                  <ExcelExportColumn
                    field="agent.code"
                    title="Mã nhân viên"
                    locked={true}
                    width={50}
                  />
                  <ExcelExportColumn
                    field="agent.username"
                    title="Nhân viên"
                    width={80}
                  />
                  <ExcelExportColumn
                    field="total"
                    title="Tổng cuộc gọi"
                    width={80}
                  />
                  <ExcelExportColumnGroup
                    title="< 1 phút (cuộc gọi)"
                    headerCellOptions={{ textAlign: "center" }}>
                    <ExcelExportColumn field="zeroToOne" title="Tổng số" />
                    <ExcelExportColumn
                      field="percentZeroToOne"
                      title="Tỉ lệ (%)"
                      width={100}
                    />
                  </ExcelExportColumnGroup>
                  <ExcelExportColumnGroup
                    title="1 - 3 phút (cuộc gọi)"
                    headerCellOptions={{ textAlign: "center" }}>
                    <ExcelExportColumn field="oneToThree" title="Tổng số" />
                    <ExcelExportColumn
                      field="percentOneToThree"
                      title="Tỉ lệ (%)"
                      width={100}
                    />
                  </ExcelExportColumnGroup>
                  <ExcelExportColumnGroup
                    title="> 3 phút (cuộc gọi)"
                    headerCellOptions={{ textAlign: "center" }}>
                    <ExcelExportColumn field="threeUpto" title="Tổng số" />
                    <ExcelExportColumn
                      field="percentThreeUpto"
                      title="Tỉ lệ (%)"
                      width={100}
                    />
                  </ExcelExportColumnGroup>
                </ExcelExport>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        {listReportAgentCallDurationResult.length != 0 ? (
          <Paper
            style={{
              marginTop: 15,
              justifyContent: "center",
              backgroundColor: "#fff",
              color: "#000",
              padding: 25,
            }}>
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="600px"
              data={dataReport}
              options={{
                title: "Duration Report",
                series: {
                  0: { targetAxisIndex: 0 },
                  1: { targetAxisIndex: 0 },
                  2: { targetAxisIndex: 0 },
                  3: { targetAxisIndex: 0 },
                },
                vAxes: {
                  0: {
                    title: "Calls",
                  },
                },
                hAxis: {
                  title: "Agent Code",
                },
              }}
              rootProps={{ "data-testid": "1" }}
            />
          </Paper>
        ) : null}
        <Paper className={classes.root}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell rowSpan="2" className={classes.head}>
                  Mã nhân viên
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Nhân viên
                </TableCell>
                <TableCell
                  rowSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  Tổng cuộc gọi
                </TableCell>
                <TableCell
                  colSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  {`< 1 phút (cuộc gọi)`}
                </TableCell>
                <TableCell
                  colSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  1 - 3 phút (cuộc gọi)
                </TableCell>
                <TableCell
                  colSpan="2"
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>{`> 3 phút (cuộc gọi)`}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tổng số
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tổng số
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tỉ lệ (%)
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tổng số
                </TableCell>
                <TableCell
                  className={classes.head}
                  style={{
                    borderRight: "1px solid rgba(224, 224, 224, 1)",
                    paddingRight: "14px",
                  }}>
                  {" "}
                  Tỉ lệ (%)
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {listReportAgentCallDurationResult != 0
                ? listReportAgentCallDurationResult.map((row, key) => {
                    return (
                      <TableRow key={key} className={classes.row}>
                        <TableCell component="th" scope="row">
                          {row.agent.code}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.agent.username}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.total === 0 ? "-" : Math.round(row.total)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.zeroToOne === 0
                            ? "-"
                            : Math.round(row.zeroToOne)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percentZeroToOne === 0
                            ? "-"
                            : row.percentZeroToOne}{" "}
                          %
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.oneToThree === 0
                            ? "-"
                            : Math.round(row.oneToThree)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percentOneToThree === 0
                            ? "-"
                            : row.percentOneToThree}{" "}
                          %
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.threeUpto === 0
                            ? "-"
                            : Math.round(row.threeUpto)}
                        </TableCell>
                        <TableCell
                          component="th"
                          scope="row"
                          style={{
                            borderRight: "1px solid rgba(224, 224, 224, 1)",
                            paddingRight: "14px",
                          }}>
                          {row.percentThreeUpto === 0
                            ? "-"
                            : row.percentThreeUpto}{" "}
                          %
                        </TableCell>
                      </TableRow>
                    );
                  })
                : null}
            </TableBody>
          </Table>
        </Paper>
        <Dialog open={this.props.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

const styles = (theme) => ({
  charts: {
    backgroundColor: "#fff",
  },
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
    justifyContent: "center",
    display: "flex",
  },
  table: {
    minWidth: 700,
  },
  input: {
    width: "100%",
  },
  form: {
    width: "100%",
  },
  rootDialog: {
    width: "100%",
    justifyContent: "center",
    display: "flex",
    overflowX: "auto",
  },
  tableRowHover: {
    "&:hover": {
      backgroundColor: "#90a4ae",
    },
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#f2f2f2",
    },
    "&:last-child": {
      backgroundColor: "#d9d9d9",
    },
  },
  head: {
    backgroundColor: "#f2f2f2",
    position: "sticky",
    top: 0,
  },
  button: {
    width: "40px",
    height: "40px",
    float: "right",
    marginTop: "-55px",
    fontSize: "16px",
  },
  fab: {
    marginRight: 10,
  },
});

ReportAgentPerformence.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listReportAgentCallDuration: state.reportAgent.reportAgentCallDuration,
  loading: state.reportAgent.loading,
});
const CampaignAction = connect(null, campaignAction)(ReportAgentPerformence);
ReportAgentPerformence = connect(
  mapStateToProps,
  mapActionsToProps
)(CampaignAction);
export default withStyles(styles)(ReportAgentPerformence);
